import { render, staticRenderFns } from "./MiniLoader.vue?vue&type=template&id=5975430e&scoped=true"
import script from "./MiniLoader.vue?vue&type=script&lang=js"
export * from "./MiniLoader.vue?vue&type=script&lang=js"
import style0 from "./MiniLoader.vue?vue&type=style&index=0&id=5975430e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5975430e",
  null
  
)

export default component.exports